module.exports = __webpack_public_path__ + "img/g_dayv.4f68589b.png";